import { useState } from 'react'
import { ignitionFetch } from '~/utils/ignitionFetch'

const useSchemaHistory = () => {
  const [schemaHistory, setSchemaHistory] = useState({ loading: true, data: null, error: null })

  const getSchemaHistory = (serviceId, token) => {
    if (!serviceId || !token) {
      setSchemaHistory({
        loading: false,
        data: null,
        error: 'Must supply a serviceId and a token to query history.'
      })
    }

    ignitionFetch(`api/v1/form_schemas/service/${serviceId}/history`, token, {})
      .then(response => {
        setSchemaHistory({ loading: false, data: response.data, error: null })
      })
      .catch(response => {
        setSchemaHistory({
          data: null,
          loading: false,
          error: response.errors
            ? response.errors
            : 'We could not find a history of enrolment form schemas for this service.'
        })
      })
  }

  return [schemaHistory, getSchemaHistory]
}

export default useSchemaHistory
